import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import { mq, pxToRem, sizes } from '../../theme'
import HeroSearch from '../../components/Hero/Search'

export const Layout = styled(MainLayout)``
export const Top = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(32)};
  }
`
export const Hero = styled(HeroSearch)``
